/**
 * Feature flags for third-party integrations.
 *
 * Outlook (Microsoft) calendar is fully wired backend-side via Recal but the
 * write-path event sync hasn't been validated end-to-end with a real Outlook
 * account. Keep the button hidden until verified. Flip OUTLOOK_ENABLED to
 * `true` once we confirm bookings push events into Outlook calendars
 * correctly. No env var needed; this is a code-controlled feature gate.
 *
 * Note: users who previously connected Outlook (before this gate landed)
 * retain their connection — only the connect buttons are hidden. The
 * disconnect path is always available.
 */
export const OUTLOOK_ENABLED = false;
